module.exports = `${require.publicPath}logo.66750a7a.png`;